// @ts-nocheck
(function attachV2CategoryConfig(root, factory) {
  const api = { create: factory };
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.NoDrillCategoryConfigV2 = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function createNdrV2CategoryConfig(data) {
  'use strict';

  function clone(value) {
    return JSON.parse(JSON.stringify(value));
  }

  function conditionsMatch(conditions, selections) {
    return !conditions || Object.entries(conditions).every(
      ([id, allowed]) => allowed.includes((selections || {})[id]),
    );
  }

  function isGroupActive(group, selections) {
    return conditionsMatch(group.activeWhen, selections || {});
  }

  function availableOptions(group, selections) {
    const selected = selections || {};
    if (!isGroupActive(group, selected)) return [];
    if ((group.dependsOn || []).some((id) => !selected[id])) return [];
    return (group.options || []).filter((option) => conditionsMatch(option.requires, selected));
  }

  function availableControls(category, selections) {
    const selected = selections || {};
    return (category.controlOrder || [])
      .map((id) => ({ id, ...category.controls[id] }))
      .filter((control) => control.enabled && conditionsMatch(control.requires, selected));
  }

  function defaultOption(group, selections) {
    const configured = (group.defaults || []).find(
      (entry) => conditionsMatch(entry.when, selections || {}),
    );
    return configured?.option || group.defaultOption || '';
  }

  function derivedOption(group, selections) {
    const selected = selections || {};
    if (!group?.derivedFrom || !conditionsMatch(group.derivedWhen, selected)) return null;
    if (!isGroupActive(group, selected)) return '';
    if ((group.dependsOn || []).some((id) => !selected[id])) return '';
    const derived = group.derivedOptionMap?.[selected[group.derivedFrom]] || '';
    const option = (group.options || []).find((candidate) => candidate.id === derived);
    return option && conditionsMatch(option.requires, selected) ? derived : '';
  }

  const noDrillOpenRoll = 'no-drill-open-roll';
  const noDrillSquareCassette = 'no-drill-square-cassette';
  const standardOpenRoll = 'standard-open-roll';
  const standardBracketCassette = 'standard-bracket-cassette';
  const bluewaterFamily = 'NDR-V2-RL-SO-108';
  const harborGridFamily = 'NDR-V2-RL-SO-102';
  const biscayneSolar3Family = 'NDR-V2-RL-SO-003';
  const biscayneSolar5Family = 'NDR-V2-RL-SO-005';
  const rollerCassetteProfileId = 'roller-cassette-shared';
  const rollerCassetteProfileRevision = 1;
  const standardBracketHeadrails = [standardOpenRoll, standardBracketCassette];
  const headrails = [noDrillOpenRoll, noDrillSquareCassette, ...standardBracketHeadrails];

  function hardwareFinishSelectorMedia(finish) {
    return {
      ...(finish === 'white' ? { 'no-drill-open-roll': 'hardware-no-drill-open-roll-white' } : {}),
      'no-drill-square-cassette': `hardware-finish-${finish}`,
      'standard-open-roll': `hardware-standard-open-roll-${finish}`,
      'standard-bracket-cassette': `hardware-standard-cassette-${finish}`,
    };
  }
  const laneByCategory = {
    'roller-shades': 'roller',
    'zebra-shades': 'zebra',
  };
  const metaByCategory = {
    'roller-shades': {
      label: 'Roller Shades',
      shortLabel: 'Roller',
      validationLabel: 'See the roller shade fabrics and options. Ordering is not available yet.',
    },
    'zebra-shades': {
      label: 'Zebra Shades',
      shortLabel: 'Zebra',
      validationLabel: 'See the Zebra shade fabrics and options. Ordering is not available yet.',
    },
  };
  const fabricTypeLabels = {
    blackout: 'Blackout',
    'light-filtering': 'Light Filtering',
    solar: 'Solar',
    'semi-blackout': 'Semi-Blackout',
  };

  function createRollerCassetteProfile() {
    return {
      id: rollerCassetteProfileId,
      revision: rollerCassetteProfileRevision,
      policy: {
        hideInapplicableDepthSummary: true,
        useInstallationOptionLabels: true,
        requireExplicitInstallationChoice: true,
        requireExplicitChainChoice: true,
        preserveCompatibleInstallationSelections: true,
        previewMeasurementDefaults: false,
        steppedBuilder: true,
        installationFirstWaitingLabel: 'Choose how to mount your shade to start.',
        noDrillDepthHelp: 'Measure the clear depth of the opening. Start at the front edge and stop at the first thing in the way.',
        customizerFlow: [
          'installation_mount',
          'hardware_finish',
          'bottom_rail',
          'fabric_color',
          'control_method',
          'measurements',
          'review',
        ],
        flowStageAliases: { headrail_style: 'hardware_finish' },
        flowStagePresentation: {
          installation_mount: {
            heading: 'How will you hang it?',
            lead: '',
          },
          hardware_finish: {
            heading: 'Pick a hardware color',
            lead: '',
          },
        },
        mountOverrides: {
          'no-drill-inside': { label: 'No-Drill Inside Mount' },
          'standard-outside': { label: 'Traditional Bracket Outside Mount' },
        },
        optionGroups: {
          installation_method: {
            defaultOption: '',
            optionOverrides: {
              'no-drill': {
                label: 'No-Drill Inside Mount',
                note: 'No tools needed to install. The shade fits inside the window opening.',
                selectorMediaKey: 'headrail-no-drill-square-cassette', // Albert, Oct 15 2026: replace the zebra-looking card picture with the cassette render.
              },
              'standard-bracket': {
                label: 'Traditional Bracket',
                note: 'Uses a drill. The brackets go outside the window.',
                selectorMediaKey: 'headrail-standard-bracket-cassette',
              },
            },
          },
          hardware_finish: {
            colorOnlyHeadrails: [standardBracketCassette],
          },
          mount_location: {
            derivedFrom: 'installation_method',
            derivedOptionMap: {
              'no-drill': 'inside',
              'standard-bracket': 'outside',
            },
            hideWhenDerived: true,
            hideFromSummary: true,
          },
          headrail_style: {
            allowedOptionIds: [noDrillSquareCassette, standardBracketCassette],
            optionOverrides: {
              [standardBracketCassette]: { label: 'Traditional Bracket Cassette' },
            },
            defaultOption: noDrillSquareCassette,
            defaults: [
              { when: { installation_method: ['no-drill'] }, option: noDrillSquareCassette },
              { when: { installation_method: ['standard-bracket'] }, option: standardBracketCassette },
            ],
            derivedFrom: 'installation_method',
            derivedOptionMap: {
              'no-drill': noDrillSquareCassette,
              'standard-bracket': standardBracketCassette,
            },
            hideWhenDerived: true,
          },
        },
      },
    };
  }

  function createRollerFamilyPolicyRecord(rolloutStatus, overrides = {}) {
    return {
      enabled: true,
      profileId: rollerCassetteProfileId,
      profileRevision: rollerCassetteProfileRevision,
      rolloutStatus,
      overrides,
    };
  }

  const rollerFamilyPolicyProfiles = {
    [rollerCassetteProfileId]: createRollerCassetteProfile(),
  };
  const rollerFamilyPolicies = {
    // D043: exact accepted colors only; no held-source substitution.
    ...Object.fromEntries([
      ["NDR-V2-RL-BO-002", ["NDR-V2-RL-BO-002-C01", "NDR-V2-RL-BO-002-C02", "NDR-V2-RL-BO-002-C03", "NDR-V2-RL-BO-002-C04", "NDR-V2-RL-BO-002-C05"]],
      ["NDR-V2-RL-BO-003", ["NDR-V2-RL-BO-003-C01", "NDR-V2-RL-BO-003-C03", "NDR-V2-RL-BO-003-C04", "NDR-V2-RL-BO-003-C05", "NDR-V2-RL-BO-003-C06"]],
      ["NDR-V2-RL-BO-004", ["NDR-V2-RL-BO-004-C01", "NDR-V2-RL-BO-004-C02", "NDR-V2-RL-BO-004-C03", "NDR-V2-RL-BO-004-C04", "NDR-V2-RL-BO-004-C05", "NDR-V2-RL-BO-004-C06", "NDR-V2-RL-BO-004-C07"]],
      ["NDR-V2-RL-BO-005", ["NDR-V2-RL-BO-005-C01", "NDR-V2-RL-BO-005-C02", "NDR-V2-RL-BO-005-C03", "NDR-V2-RL-BO-005-C04", "NDR-V2-RL-BO-005-C05", "NDR-V2-RL-BO-005-C06", "NDR-V2-RL-BO-005-C07"]],
      ["NDR-V2-RL-BO-006", ["NDR-V2-RL-BO-006-C01", "NDR-V2-RL-BO-006-C02", "NDR-V2-RL-BO-006-C03", "NDR-V2-RL-BO-006-C04", "NDR-V2-RL-BO-006-C05", "NDR-V2-RL-BO-006-C06", "NDR-V2-RL-BO-006-C07"]],
      ["NDR-V2-RL-BO-007", ["NDR-V2-RL-BO-007-C01", "NDR-V2-RL-BO-007-C02", "NDR-V2-RL-BO-007-C03", "NDR-V2-RL-BO-007-C04", "NDR-V2-RL-BO-007-C05", "NDR-V2-RL-BO-007-C06", "NDR-V2-RL-BO-007-C07"]],
      ["NDR-V2-RL-BO-008", ["NDR-V2-RL-BO-008-C01", "NDR-V2-RL-BO-008-C02", "NDR-V2-RL-BO-008-C03", "NDR-V2-RL-BO-008-C04", "NDR-V2-RL-BO-008-C05", "NDR-V2-RL-BO-008-C06"]],
      ["NDR-V2-RL-BO-009", ["NDR-V2-RL-BO-009-C01", "NDR-V2-RL-BO-009-C02", "NDR-V2-RL-BO-009-C03", "NDR-V2-RL-BO-009-C04", "NDR-V2-RL-BO-009-C05", "NDR-V2-RL-BO-009-C06", "NDR-V2-RL-BO-009-C07"]],
      ["NDR-V2-RL-BO-010", ["NDR-V2-RL-BO-010-C01", "NDR-V2-RL-BO-010-C02", "NDR-V2-RL-BO-010-C03", "NDR-V2-RL-BO-010-C04", "NDR-V2-RL-BO-010-C05", "NDR-V2-RL-BO-010-C06", "NDR-V2-RL-BO-010-C07"]],
      ["NDR-V2-RL-BO-011", ["NDR-V2-RL-BO-011-C01", "NDR-V2-RL-BO-011-C02", "NDR-V2-RL-BO-011-C03", "NDR-V2-RL-BO-011-C04"]],
      ["NDR-V2-RL-BO-012", ["NDR-V2-RL-BO-012-C01", "NDR-V2-RL-BO-012-C02", "NDR-V2-RL-BO-012-C03", "NDR-V2-RL-BO-012-C04"]],
      ["NDR-V2-RL-BO-013", ["NDR-V2-RL-BO-013-C01", "NDR-V2-RL-BO-013-C02", "NDR-V2-RL-BO-013-C03", "NDR-V2-RL-BO-013-C04", "NDR-V2-RL-BO-013-C05", "NDR-V2-RL-BO-013-C06"]],
      ["NDR-V2-RL-BO-014", ["NDR-V2-RL-BO-014-C01", "NDR-V2-RL-BO-014-C02", "NDR-V2-RL-BO-014-C03", "NDR-V2-RL-BO-014-C04", "NDR-V2-RL-BO-014-C05"]],
      ["NDR-V2-RL-BO-015", ["NDR-V2-RL-BO-015-C01", "NDR-V2-RL-BO-015-C02", "NDR-V2-RL-BO-015-C03", "NDR-V2-RL-BO-015-C04"]],
      ["NDR-V2-RL-BO-016", ["NDR-V2-RL-BO-016-C01", "NDR-V2-RL-BO-016-C02"]],
      ["NDR-V2-RL-SO-109", ["NDR-V2-RL-SO-109-C01", "NDR-V2-RL-SO-109-C02", "NDR-V2-RL-SO-109-C03"]]
    ].map(([id, colors]) => [id, createRollerFamilyPolicyRecord('local-private-candidate', {
      catalogReferenceIsExactPreview: false,
      materialReadiness: 'accepted-native-dual-mount-runtime-candidate',
      deploymentEligible: false,
      priceStatus: 'quote-pending',
      launchEligible: false,
      checkoutEnabled: false,
      optionGroups: { fabric_color: { defaultOption: colors[0], allowedOptionIds: colors } },
    })])),
    [bluewaterFamily]: createRollerFamilyPolicyRecord('accepted-private-baseline', {
      recommendedOptions: { installation_method: 'no-drill', hardware_finish: 'white', bottom_rail: 'regular' },
      recommendationLabel: 'Most popular',
      recommendationLabels: { installation_method: 'Recommended' },
    }),
    [harborGridFamily]: createRollerFamilyPolicyRecord('local-private-candidate', {
      rolloutStatus: 'local-private-candidate',
      catalogReferenceIsExactPreview: false,
      materialReadiness: 'nine-native-colors',
      deploymentEligible: false,
      priceStatus: 'quote-pending',
      launchEligible: false,
      checkoutEnabled: false,
      optionGroups: {
        fabric_color: { defaultOption: `${harborGridFamily}-C01`, allowedOptionIds: Array.from({ length: 9 }, (_, i) => `${harborGridFamily}-C0${i + 1}`), note: '' },
      },
    }),
    [biscayneSolar3Family]: createRollerFamilyPolicyRecord('local-private-candidate', {
      rolloutStatus: 'local-private-candidate',
      catalogReferenceIsExactPreview: false,
      materialReadiness: 'registered-private-runtime-candidate',
      deploymentEligible: false,
      priceStatus: 'quote-pending',
      launchEligible: false,
      checkoutEnabled: false,
      optionGroups: {
        fabric_color: { defaultOption: `${biscayneSolar3Family}-C01` },
      },
    }),
    [biscayneSolar5Family]: createRollerFamilyPolicyRecord('local-private-candidate', {
      rolloutStatus: 'local-private-candidate',
      catalogReferenceIsExactPreview: false,
      materialReadiness: 'registered-private-runtime-candidate',
      deploymentEligible: false,
      priceStatus: 'quote-pending',
      launchEligible: false,
      checkoutEnabled: false,
      optionGroups: {
        fabric_color: { defaultOption: `${biscayneSolar5Family}-C01` },
      },
    }),
    ['NDR-V2-RL-SO-103']: createRollerFamilyPolicyRecord('local-private-candidate', {
      rolloutStatus: 'local-private-candidate',
      catalogReferenceIsExactPreview: false,
      materialReadiness: 'accepted-native-dual-mount-runtime-candidate',
      deploymentEligible: false,
      priceStatus: 'quote-pending',
      launchEligible: false,
      checkoutEnabled: false,
      optionGroups: {
        fabric_color: { defaultOption: 'NDR-V2-RL-SO-103-C01' },
      },
    }),
    ['NDR-V2-RL-SO-104']: createRollerFamilyPolicyRecord('local-private-candidate', {
      rolloutStatus: 'local-private-candidate',
      catalogReferenceIsExactPreview: false,
      materialReadiness: 'accepted-native-dual-mount-runtime-candidate',
      deploymentEligible: false,
      priceStatus: 'quote-pending',
      launchEligible: false,
      checkoutEnabled: false,
      optionGroups: {
        fabric_color: {
          defaultOption: 'NDR-V2-RL-SO-104-C01',
          allowedOptionIds: [
            'NDR-V2-RL-SO-104-C01', 'NDR-V2-RL-SO-104-C02', 'NDR-V2-RL-SO-104-C03',
            'NDR-V2-RL-SO-104-C04', 'NDR-V2-RL-SO-104-C05', 'NDR-V2-RL-SO-104-C06', 'NDR-V2-RL-SO-104-C07', 'NDR-V2-RL-SO-104-C08',
          ],
        },
      },
    }),
    ['NDR-V2-RL-SO-107']: createRollerFamilyPolicyRecord('local-private-candidate', {
      rolloutStatus: 'local-private-candidate',
      catalogReferenceIsExactPreview: false,
      materialReadiness: 'accepted-native-dual-mount-runtime-candidate',
      deploymentEligible: false,
      priceStatus: 'quote-pending',
      launchEligible: false,
      checkoutEnabled: false,
      optionGroups: {
        fabric_color: {
          defaultOption: 'NDR-V2-RL-SO-107-C01',
          allowedOptionIds: [
            'NDR-V2-RL-SO-107-C01', 'NDR-V2-RL-SO-107-C02', 'NDR-V2-RL-SO-107-C03',
            'NDR-V2-RL-SO-107-C04', 'NDR-V2-RL-SO-107-C05', 'NDR-V2-RL-SO-107-C06', 'NDR-V2-RL-SO-107-C07', 'NDR-V2-RL-SO-107-C08',
          ],
        },
      },
    }),
    ['NDR-V2-RL-SO-105']: createRollerFamilyPolicyRecord('local-private-candidate', {
      rolloutStatus: 'local-private-candidate',
      catalogReferenceIsExactPreview: false,
      materialReadiness: 'accepted-native-dual-mount-runtime-candidate',
      deploymentEligible: false,
      priceStatus: 'quote-pending',
      launchEligible: false,
      checkoutEnabled: false,
      optionGroups: {
        fabric_color: { defaultOption: 'NDR-V2-RL-SO-105-C01' },
      },
    }),
    ['NDR-V2-RL-LF-001']: createRollerFamilyPolicyRecord('local-private-candidate', {
      rolloutStatus: 'local-private-candidate',
      catalogReferenceIsExactPreview: false,
      materialReadiness: 'partial-parent-accepted-inside-only',
      deploymentEligible: false,
      priceStatus: 'quote-pending',
      launchEligible: false,
      checkoutEnabled: false,
      optionGroups: {
        fabric_color: {"defaultOption": "NDR-V2-RL-LF-001-C05", "allowedOptionIds": ["NDR-V2-RL-LF-001-C05", "NDR-V2-RL-LF-001-C02", "NDR-V2-RL-LF-001-C03", "NDR-V2-RL-LF-001-C04"], "note": "Other colors are not an option now."},
      },
    }),
    ['NDR-V2-RL-LF-002']: createRollerFamilyPolicyRecord('local-private-candidate', {
      rolloutStatus: 'local-private-candidate',
      catalogReferenceIsExactPreview: false,
      materialReadiness: 'partial-parent-accepted-inside-only',
      deploymentEligible: false,
      priceStatus: 'quote-pending',
      launchEligible: false,
      checkoutEnabled: false,
      optionGroups: {
        fabric_color: {"defaultOption": "NDR-V2-RL-LF-002-C01", "allowedOptionIds": ["NDR-V2-RL-LF-002-C01", "NDR-V2-RL-LF-002-C02", "NDR-V2-RL-LF-002-C03", "NDR-V2-RL-LF-002-C04", "NDR-V2-RL-LF-002-C05"], "note": ""},
      },
    }),
    ['NDR-V2-RL-LF-003']: createRollerFamilyPolicyRecord('local-private-candidate', {
      rolloutStatus: 'local-private-candidate',
      catalogReferenceIsExactPreview: false,
      materialReadiness: 'partial-parent-accepted-inside-only',
      deploymentEligible: false,
      priceStatus: 'quote-pending',
      launchEligible: false,
      checkoutEnabled: false,
      optionGroups: {
        fabric_color: {"defaultOption": "NDR-V2-RL-LF-003-C06", "allowedOptionIds": ["NDR-V2-RL-LF-003-C06", "NDR-V2-RL-LF-003-C02", "NDR-V2-RL-LF-003-C01", "NDR-V2-RL-LF-003-C03", "NDR-V2-RL-LF-003-C04", "NDR-V2-RL-LF-003-C05"], "note": ""},
      },
    }),
    ['NDR-V2-RL-LF-004']: createRollerFamilyPolicyRecord('local-private-candidate', {
      rolloutStatus: 'local-private-candidate',
      catalogReferenceIsExactPreview: false,
      materialReadiness: 'partial-parent-accepted-inside-only',
      deploymentEligible: false,
      priceStatus: 'quote-pending',
      launchEligible: false,
      checkoutEnabled: false,
      optionGroups: {
        fabric_color: {"defaultOption": "NDR-V2-RL-LF-004-C05", "allowedOptionIds": ["NDR-V2-RL-LF-004-C05", "NDR-V2-RL-LF-004-C01", "NDR-V2-RL-LF-004-C02", "NDR-V2-RL-LF-004-C03", "NDR-V2-RL-LF-004-C04", "NDR-V2-RL-LF-004-C06", "NDR-V2-RL-LF-004-C07"], "note": ""},
      },
    }),
    ['NDR-V2-RL-LF-005']: createRollerFamilyPolicyRecord('local-private-candidate', {
      rolloutStatus: 'local-private-candidate',
      catalogReferenceIsExactPreview: false,
      materialReadiness: 'partial-parent-accepted-inside-only',
      deploymentEligible: false,
      priceStatus: 'quote-pending',
      launchEligible: false,
      checkoutEnabled: false,
      optionGroups: {
        fabric_color: {"defaultOption": "NDR-V2-RL-LF-005-C05", "allowedOptionIds": ["NDR-V2-RL-LF-005-C05", "NDR-V2-RL-LF-005-C06", "NDR-V2-RL-LF-005-C07", "NDR-V2-RL-LF-005-C01", "NDR-V2-RL-LF-005-C02", "NDR-V2-RL-LF-005-C03", "NDR-V2-RL-LF-005-C04"], "note": ""},
      },
    }),
    ['NDR-V2-RL-LF-006']: createRollerFamilyPolicyRecord('local-private-candidate', {
      rolloutStatus: 'local-private-candidate',
      catalogReferenceIsExactPreview: false,
      materialReadiness: 'partial-parent-accepted-inside-only',
      deploymentEligible: false,
      priceStatus: 'quote-pending',
      launchEligible: false,
      checkoutEnabled: false,
      optionGroups: {
        fabric_color: {"defaultOption": "NDR-V2-RL-LF-006-C01", "allowedOptionIds": ["NDR-V2-RL-LF-006-C01", "NDR-V2-RL-LF-006-C02", "NDR-V2-RL-LF-006-C03", "NDR-V2-RL-LF-006-C04"], "note": ""},
      },
    }),
    ['NDR-V2-RL-LF-007']: createRollerFamilyPolicyRecord('local-private-candidate', {
      rolloutStatus: 'local-private-candidate',
      catalogReferenceIsExactPreview: false,
      materialReadiness: 'partial-parent-accepted-inside-only',
      deploymentEligible: false,
      priceStatus: 'quote-pending',
      launchEligible: false,
      checkoutEnabled: false,
      optionGroups: {
        fabric_color: {"defaultOption": "NDR-V2-RL-LF-007-C01", "allowedOptionIds": ["NDR-V2-RL-LF-007-C01", "NDR-V2-RL-LF-007-C02", "NDR-V2-RL-LF-007-C03", "NDR-V2-RL-LF-007-C04", "NDR-V2-RL-LF-007-C05"], "note": ""},
      },
    }),
    ['NDR-V2-RL-LF-008']: createRollerFamilyPolicyRecord('local-private-candidate', {
      rolloutStatus: 'local-private-candidate',
      catalogReferenceIsExactPreview: false,
      materialReadiness: 'partial-parent-accepted-inside-only',
      deploymentEligible: false,
      priceStatus: 'quote-pending',
      launchEligible: false,
      checkoutEnabled: false,
      optionGroups: {
        fabric_color: {"defaultOption": "NDR-V2-RL-LF-008-C02", "allowedOptionIds": ["NDR-V2-RL-LF-008-C02", "NDR-V2-RL-LF-008-C03", "NDR-V2-RL-LF-008-C04", "NDR-V2-RL-LF-008-C05", "NDR-V2-RL-LF-008-C01", "NDR-V2-RL-LF-008-C06"], "note": ""},
      },
    }),
    ['NDR-V2-RL-BO-001']: createRollerFamilyPolicyRecord('local-private-candidate', {
      rolloutStatus: 'local-private-candidate',
      catalogReferenceIsExactPreview: false,
      materialReadiness: 'accepted-native-dual-mount-pilot-runtime-candidate',
      deploymentEligible: false,
      priceStatus: 'quote-pending',
      launchEligible: false,
      checkoutEnabled: false,
      optionGroups: { fabric_color: {"defaultOption": "NDR-V2-RL-BO-001-C01", "allowedOptionIds": ["NDR-V2-RL-BO-001-C01", "NDR-V2-RL-BO-001-C02", "NDR-V2-RL-BO-001-C03", "NDR-V2-RL-BO-001-C04", "NDR-V2-RL-BO-001-C05"]} },
    }),
    ['NDR-V2-RL-LF-009']: createRollerFamilyPolicyRecord('local-private-candidate', {
      rolloutStatus: 'local-private-candidate',
      catalogReferenceIsExactPreview: false,
      materialReadiness: 'accepted-native-inside-pilot-runtime-candidate',
      deploymentEligible: false,
      priceStatus: 'quote-pending',
      launchEligible: false,
      checkoutEnabled: false,
      optionGroups: {
        fabric_color: { defaultOption: 'NDR-V2-RL-LF-009-C01' },
      },
    }),
    ['NDR-V2-RL-SO-001']: createRollerFamilyPolicyRecord('local-private-candidate', {
      rolloutStatus: 'local-private-candidate',
      catalogReferenceIsExactPreview: false,
      materialReadiness: 'accepted-native-dual-mount-runtime-candidate',
      deploymentEligible: false,
      priceStatus: 'quote-pending',
      launchEligible: false,
      checkoutEnabled: false,
      optionGroups: {
        fabric_color: { defaultOption: 'NDR-V2-RL-SO-001-C01' },
      },
    }),
    ['NDR-V2-RL-SO-101']: createRollerFamilyPolicyRecord('local-private-candidate', {
      rolloutStatus: 'local-private-candidate',
      catalogReferenceIsExactPreview: false,
      materialReadiness: 'accepted-native-dual-mount-runtime-candidate',
      deploymentEligible: false,
      priceStatus: 'quote-pending',
      launchEligible: false,
      checkoutEnabled: false,
      optionGroups: {
        fabric_color: { defaultOption: 'NDR-V2-RL-SO-101-C01' },
      },
    }),
    ['NDR-V2-RL-SO-106']: createRollerFamilyPolicyRecord('local-private-candidate', {
      rolloutStatus: 'local-private-candidate',
      catalogReferenceIsExactPreview: false,
      materialReadiness: 'accepted-native-dual-mount-runtime-candidate',
      deploymentEligible: false,
      priceStatus: 'quote-pending',
      launchEligible: false,
      checkoutEnabled: false,
      optionGroups: {
        fabric_color: { defaultOption: 'NDR-V2-RL-SO-106-C01' },
      },
    }),
  };

  // Corrected Wave 1 includes both mounts; retain private material and commerce gates.
  const wave1RollerFamilies = [
    'NDR-V2-RL-SO-001', 'NDR-V2-RL-SO-003', 'NDR-V2-RL-SO-005',
    'NDR-V2-RL-SO-101', 'NDR-V2-RL-SO-102', 'NDR-V2-RL-SO-103',
    'NDR-V2-RL-SO-104', 'NDR-V2-RL-SO-105', 'NDR-V2-RL-SO-106', 'NDR-V2-RL-SO-107',
  ];
  wave1RollerFamilies.forEach((familyId) => {
    const record = rollerFamilyPolicies[familyId] || createRollerFamilyPolicyRecord('preparing-private-candidate', {
      catalogReferenceIsExactPreview: false,
      materialReadiness: 'source-and-map-preparation-pending',
      deploymentEligible: false,
      priceStatus: 'quote-pending',
      launchEligible: false,
      checkoutEnabled: false,
      optionGroups: { fabric_color: { defaultOption: `${familyId}-C01` } },
    });
    const overrides = record.overrides || {};
    rollerFamilyPolicies[familyId] = {
      ...record,
      overrides: {
        ...overrides,
        optionGroups: {
          ...overrides.optionGroups,
          installation_method: {
            ...rollerFamilyPolicyProfiles[rollerCassetteProfileId].policy.optionGroups.installation_method,
            ...overrides.optionGroups?.installation_method,
            allowedOptionIds: ['no-drill', 'standard-bracket'],
          },
        },
      },
    };
  });

  function createVisualCategory(categoryId) {
    const laneKey = laneByCategory[categoryId];
    const meta = metaByCategory[categoryId];
    const lane = data[laneKey] || {};
    const families = Array.isArray(lane.families) ? lane.families : [];
    const variants = Array.isArray(lane.variants) ? lane.variants : [];
    const configurableFamilies = families.filter((family) => family.configurationEligible === true);
    const configurableFamilyIds = new Set(configurableFamilies.map((family) => family.id));
    const configurableVariants = variants.filter((variant) => configurableFamilyIds.has(variant.familyId));
    const fabricTypes = Array.from(new Set(configurableFamilies.flatMap((family) => family.fabricTypes || [])));
    const buildEligible = families.length > 0
      && variants.length > 0
      && families.every((family) => family.buildEligible && !family.launchEligible)
      && variants.every((variant) => variant.selectorMediaKey);
    const configurationEnabled = buildEligible
      && configurableFamilies.length > 0
      && configurableVariants.length > 0;
    const defaultFamily = configurableFamilies[0] || null;
    const defaultFabricType = defaultFamily?.fabricTypes?.[0] || '';
    const isRollerCategory = categoryId === 'roller-shades';
    const supportedHeadrails = isRollerCategory ? headrails : [noDrillSquareCassette];
    const bottomRailStyles = isRollerCategory ? [
      {
        id: 'regular',
        label: 'Finished Bottom Rail',
        selectorMediaKey: 'bottom-rail-roller-regular',
        requires: { headrail_style: supportedHeadrails },
      },
      {
        id: 'fabric-covered',
        label: 'Fabric-Covered Bottom Rail',
        selectorMediaKey: 'bottom-rail-roller-fabric-covered',
        requires: { headrail_style: supportedHeadrails },
      },
    ] : [
      {
        id: 'square-style',
        label: 'Square Style Bottom Rail',
        selectorMediaKey: 'bottom-rail-zebra-square',
        requires: { headrail_style: supportedHeadrails },
      },
      {
        id: 'u-shaped-insert',
        label: 'U-Shaped Insert Bottom Rail',
        selectorMediaKey: 'bottom-rail-zebra-u-shaped-insert',
        requires: { headrail_style: supportedHeadrails },
      },
      {
        id: 'wrapped-cloth',
        label: 'Wrapped Cloth Bottom Rail',
        selectorMediaKey: 'bottom-rail-zebra-wrapped-cloth',
        requires: { headrail_style: supportedHeadrails },
      },
      {
        id: 'vase',
        label: 'Vase Bottom Rail',
        selectorMediaKey: 'bottom-rail-zebra-vase',
        requires: { headrail_style: supportedHeadrails },
      },
    ];
    const bottomRailFinishes = isRollerCategory ? [
      { id: 'white', label: 'White', canonicalFinishId: 'white', requires: { bottom_rail: ['regular'] } },
      { id: 'beige', label: 'Beige', canonicalFinishId: 'beige', requires: { bottom_rail: ['regular'] } },
      { id: 'gray', label: 'Gray', canonicalFinishId: 'gray', requires: { bottom_rail: ['regular'] } },
      { id: 'black', label: 'Black', canonicalFinishId: 'black', requires: { bottom_rail: ['regular'] } },
    ] : [
      { id: 'white', label: 'White', requires: { bottom_rail: ['square-style', 'u-shaped-insert', 'wrapped-cloth', 'vase'] } },
      { id: 'beige', label: 'Beige', requires: { bottom_rail: ['square-style', 'u-shaped-insert'] } },
      { id: 'gray', label: 'Gray', requires: { bottom_rail: ['square-style', 'u-shaped-insert'] } },
      { id: 'black', label: 'Black', requires: { bottom_rail: ['square-style', 'u-shaped-insert'] } },
    ];

    return {
      id: categoryId,
      label: meta.label,
      displayLabel: meta.label,
      shortLabel: meta.shortLabel,
      catalogRevision: data.catalogRevision,
      catalogEligible: buildEligible,
      configurationEnabled,
      buildEligible,
      launchEligible: false,
      checkoutEnabled: false,
      priceStatus: isRollerCategory ? 'provisional-internal-bluewater-only' : 'quote-pending',
      mediaStatus: 'catalog-reference',
      validationLabel: meta.validationLabel,
      materialSwatchText: 'Documentary catalog swatches',
      mountValidation: { status: 'provisional-finalization-pending' },
      familyPolicyProfiles: isRollerCategory ? rollerFamilyPolicyProfiles : {},
      familyPolicies: isRollerCategory ? rollerFamilyPolicies : {},
      steppedBuilder: isRollerCategory,
      customizerFlow: [
        'installation_mount',
        'headrail_style',
        'bottom_rail',
        'fabric_color',
        'control_method',
        'measurements',
        'window_details',
        'review',
      ],
      controlPreviewInstallation: 'no-drill',
      requireExplicitControlChoice: true,
      lockedOptionLabels: {
        fabric_type: Object.fromEntries(fabricTypes.map((id) => [id, fabricTypeLabels[id] || id])),
      },
      measurement: {
        status: 'entry-enabled',
        minWidth: 19.75,
        maxWidth: 78.625,
        minHeight: 24,
        maxHeight: 94.375,
        increment: 0.125,
        confirmedSizeEnvelope: {
          headrailStyle: noDrillSquareCassette,
          headrailStyles: [noDrillSquareCassette, standardBracketCassette],
          evidenceStatus: 'historical-envelope-with-D040-provisional-storefront-cap',
          previewExtensionStatus: 'owner-authorized-provisional-standard-bracket',
          controls: {
            cordless: {
              minWidthMm: 500,
              maxWidthMm: 2000,
              maxHeightMm: 2200,
              heightQualifier: 'maximum',
            },
            motorized: {
              minWidthMm: 550,
              maxWidthMm: 2000,
              maxHeightMm: 2500, // Factory, Oct 12 2026: up to 2.5 m high (first quote said 280 cm). Store-wide cap in no-drill-configurator-core.js stops at 94 3/8 in.
              heightQualifier: 'maximum',
            },
          },
        },
      },
      optionGroups: [
        {
          id: 'installation_method',
          stage: 'installation',
          label: 'Installation method',
          required: true,
          defaultOption: 'no-drill',
          display: 'cards',
          options: isRollerCategory ? [
            {
              id: 'no-drill',
              label: 'Inside Mount - No Drill',
              note: 'No tools needed to install. The shade fits inside the window opening.',
              selectorMediaKey: 'headrail-square-cassette',
            },
            {
              id: 'standard-bracket',
              label: 'Outside Mount - Traditional Bracket',
              note: 'Drilling and tools required. The brackets go outside the window opening.',
              selectorMediaKey: 'headrail-standard-open-roll',
            },
          ] : [
            {
              id: 'no-drill',
              label: 'Inside Mount - No Drill',
              note: 'Mount the shade inside the opening. No drilling is needed.',
              selectorMediaKey: 'headrail-square-cassette',
            },
          ],
        },
        {
          id: 'fabric_type',
          label: 'Fabric type',
          required: true,
          defaultOption: defaultFabricType,
          display: 'cards',
          options: fabricTypes.map((id) => ({
            id,
            label: fabricTypeLabels[id] || id,
            note: 'See fabric styles and colors.',
          })),
        },
        {
          id: 'fabric_family',
          label: 'Fabric collection',
          required: true,
          dependsOn: ['fabric_type'],
          waitingLabel: 'Choose a fabric type first.',
          defaultOption: defaultFamily?.id || '',
          display: 'cards',
          options: configurableFamilies.map((family) => ({
            id: family.id,
            label: family.label,
            selectorMediaKey: family.representativeMediaKey,
            roomMediaKey: family.roomMediaKey,
            configurationEligible: true,
            requires: { fabric_type: family.fabricTypes },
          })),
        },
        {
          id: 'fabric_color',
          label: 'Color',
          note: 'Use a fabric sample to see your color in person.',
          required: true,
          dependsOn: ['fabric_family'],
          waitingLabel: 'Pick a fabric collection before you go on.',
          defaultOption: isRollerCategory
            ? (configurableVariants.find((variant) => variant.id === 'NDR-V2-RL-SO-108-C05')?.id || configurableVariants[0]?.id || '')
            : configurableVariants[0]?.id || '',
          display: 'cards',
          options: configurableVariants.map((variant) => ({
            id: variant.id,
            label: variant.label,
            selectorMediaKey: variant.selectorMediaKey,
            weaveDetailMediaKey: variant.weaveDetailMediaKey,
            requires: { fabric_type: [variant.fabricType], fabric_family: [variant.familyId] },
          })),
        },
        {
          id: 'headrail_style',
          stage: 'headrail',
          label: 'Headrail style',
          required: true,
          dependsOn: ['installation_method'],
          waitingLabel: 'Confirm how the shade will mount first.',
          defaultOption: noDrillSquareCassette,
          defaults: [
            { when: { installation_method: ['no-drill'] }, option: noDrillSquareCassette },
            { when: { installation_method: ['standard-bracket'] }, option: standardOpenRoll },
          ],
          display: 'cards',
          options: isRollerCategory ? [
            {
              id: noDrillOpenRoll,
              label: 'No-Drill Open Roll',
              fabricWrapped: false,
              selectorMediaKey: 'headrail-no-drill-open-roll',
              requires: { installation_method: ['no-drill'] },
            },
            {
              id: noDrillSquareCassette,
              label: 'No-Drill Square Cassette',
              fabricWrapped: false,
              selectorMediaKey: 'headrail-square-cassette',
              requires: { installation_method: ['no-drill'] },
            },
            {
              id: standardOpenRoll,
              label: 'Standard Bracket Open Roll',
              fabricWrapped: false,
              selectorMediaKey: 'headrail-standard-open-roll',
              requires: { installation_method: ['standard-bracket'] },
            },
            {
              id: standardBracketCassette,
              label: 'Standard Bracket Cassette',
              fabricWrapped: false,
              selectorMediaKey: 'headrail-standard-bracket-cassette',
              requires: { installation_method: ['standard-bracket'] },
            },
          ] : [
            {
              id: noDrillSquareCassette,
              label: 'No-Drill Square Cassette',
              fabricWrapped: false,
              selectorMediaKey: 'headrail-square-cassette',
              requires: { installation_method: ['no-drill'] },
            },
          ],
        },
        {
          id: 'hardware_finish',
          stage: 'headrail',
          label: 'Hardware finish',
          requiredWhen: { headrail_style: supportedHeadrails },
          activeWhen: { headrail_style: supportedHeadrails },
          dependsOn: ['headrail_style'],
          waitingLabel: 'Confirm the headrail first.',
          defaultOption: 'white',
          hideWhenSingleOption: true,
          display: 'cards',
          options: [
            { id: 'white', label: 'White', canonicalFinishId: 'white', availabilityStatus: 'provisional', selectorMediaKey: 'hardware-finish-white', selectorMediaKeyByHeadrail: hardwareFinishSelectorMedia('white'), requires: { headrail_style: supportedHeadrails } },
            { id: 'beige', label: 'Beige', canonicalFinishId: 'beige', availabilityStatus: 'provisional', selectorMediaKey: 'hardware-finish-beige', selectorMediaKeyByHeadrail: hardwareFinishSelectorMedia('beige'), requires: { headrail_style: [noDrillSquareCassette, ...standardBracketHeadrails] } },
            { id: 'gray', label: 'Gray', canonicalFinishId: 'gray', availabilityStatus: 'provisional', selectorMediaKey: 'hardware-finish-gray', selectorMediaKeyByHeadrail: hardwareFinishSelectorMedia('gray'), requires: { headrail_style: [noDrillSquareCassette, ...standardBracketHeadrails] } },
            { id: 'black', label: 'Black', canonicalFinishId: 'black', availabilityStatus: 'provisional', selectorMediaKey: 'hardware-finish-black', selectorMediaKeyByHeadrail: hardwareFinishSelectorMedia('black'), requires: { headrail_style: [noDrillSquareCassette, ...standardBracketHeadrails] } },
          ],
        },
        {
          id: 'mount_location',
          stage: 'installation',
          label: 'Mount location',
          required: true,
          dependsOn: ['installation_method'],
          defaultOption: '',
          defaults: [
            { when: { installation_method: ['no-drill'] }, option: 'inside' },
            { when: { installation_method: ['standard-bracket'] }, option: 'outside' },
          ],
          hideWhenSingleOption: true,
          display: 'cards',
          options: isRollerCategory ? [
            { id: 'inside', label: 'Inside Mount', requires: { installation_method: ['no-drill'] } },
            { id: 'outside', label: 'Outside Mount', requires: { installation_method: ['standard-bracket'] } },
          ] : [
            { id: 'inside', label: 'Inside Mount', requires: { installation_method: ['no-drill'] } },
          ],
        },
        {
          id: 'bottom_rail',
          stage: 'bottom-rail',
          label: 'Bottom rail',
          note: 'Choose the style for the bottom edge of your shade.',
          required: true,
          defaultOption: 'regular',
          dependsOn: ['headrail_style'],
          waitingLabel: 'Choose a headrail style first.',
          compatibilityStatus: 'compatibility-confirmation-required',
          display: 'cards',
          options: bottomRailStyles,
        },
        {
          id: 'bottom_rail_finish',
          stage: 'bottom-rail',
          label: 'Bottom rail finish',
          note: 'Choose a finish for the bottom rail.',
          ...(isRollerCategory
            ? {
                requiredWhen: { bottom_rail: ['regular'] },
                activeWhen: { bottom_rail: ['regular'] },
                derivedFrom: 'hardware_finish',
                derivedWhen: { headrail_style: [noDrillSquareCassette, standardBracketCassette] },
                derivedOptionMap: {
                  white: 'white',
                  beige: 'beige',
                  gray: 'gray',
                  black: 'black',
                },
                hideWhenDerived: true,
              }
            : { required: true }),
          dependsOn: ['bottom_rail'],
          waitingLabel: 'Choose a bottom rail style first.',
          compatibilityStatus: 'compatibility-confirmation-required',
          display: 'cards',
          options: bottomRailFinishes,
        },
      ],
      defaultMount: 'no-drill-inside',
      mounts: isRollerCategory ? {
        'no-drill-inside': {
          label: 'Inside mount · No-Drill',
          enabled: true,
          allowedMountTypes: ['inside'],
          surchargeCents: 0,
          note: 'Sizing is not available for this shade yet.',
        },
        'standard-outside': {
          label: 'Outside mount · Standard Bracket',
          enabled: true,
          allowedMountTypes: ['outside'],
          surchargeCents: 0,
          note: 'Sizing is not available for this shade yet.',
        },
      } : {
        'no-drill-inside': {
          label: 'Inside mount · No-Drill Square Cassette',
          enabled: true,
          allowedMountTypes: ['inside'],
          surchargeCents: 0,
          note: 'Sizing is not available for this shade yet.',
        },
      },
      controlOrder: ['cordless', 'motorized'],
      defaultControlByInstallation: { 'no-drill': 'cordless', 'standard-bracket': 'cordless' },
      controls: {
        cordless: {
          enabled: true,
          label: 'Cordless',
          cardNote: 'Push the bottom bar up or pull it down by hand. It stays where you let go.',
          surchargeCents: 0,
          selectorMediaKey: 'control-cordless',
          requires: { headrail_style: supportedHeadrails },
        },
        motorized: {
          enabled: true,
          label: 'Motorized',
          cardNote: 'Runs by remote. There is no chain to pull.',
          surchargeCents: 0,
          selectorMediaKey: 'control-motorized',
          requires: { headrail_style: supportedHeadrails },
        },
      },
      upgrades: {},
      accessories: {},
      accessoryNone: {
        id: 'none',
        label: 'No accessories',
        note: 'This shade setup has no add-ons.',
      },
      priceBands: [],
    };
  }

  const categories = {
    'roller-shades': createVisualCategory('roller-shades'),
    'zebra-shades': createVisualCategory('zebra-shades'),
    'shangri-la-sheer-shades': {
      id: 'shangri-la-sheer-shades',
      label: 'Sheer Shades',
      displayLabel: 'Sheer Shades',
      shortLabel: 'Sheer',
      catalogRevision: data.catalogRevision,
      catalogEligible: true,
      configurationEnabled: false,
      buildEligible: false,
      launchEligible: false,
      checkoutEnabled: false,
      priceStatus: 'quote-pending',
      mediaStatus: 'blocked',
      validationLabel: 'You cannot build a Sheer shade yet.',
      materialSwatchText: 'Swatches pending',
      mountValidation: { status: 'unresolved' },
      customizerFlow: [],
      optionGroups: [],
      controlOrder: [],
      controls: {},
      measurement: { status: 'unresolved' },
      priceBands: [],
      upgrades: {},
      accessories: {},
    },
  };
  const orderPricing = { discountTiers: [] };

  function getCategory(id) {
    return categories[id] ? clone(categories[id]) : null;
  }

  function listCatalogCategories() {
    return Object.values(categories).filter((category) => category.catalogEligible).map(clone);
  }

  function applyFamilyPolicy(category, selections) {
    const familyId = selections?.fabric_family || '';
    const record = category?.familyPolicies?.[familyId];
    if (!record?.enabled) return category;
    const profile = category?.familyPolicyProfiles?.[record.profileId];
    if (!profile || profile.revision !== record.profileRevision) return category;
    const overrides = clone(record.overrides || {});
    const policy = {
      ...clone(profile.policy),
      ...overrides,
      optionGroups: {
        ...clone(profile.policy.optionGroups || {}),
        ...clone(overrides.optionGroups || {}),
      },
    };
    ['mount_location', 'headrail_style'].forEach((groupId) => {
      if (policy.optionGroups?.[groupId]?.derivedFrom) {
        policy.optionGroups[groupId].derivedWhen = { fabric_family: [familyId] };
      }
    });
    const configured = clone(category);
    configured.appliedFamilyPolicy = familyId;
    Object.entries(policy).forEach(([key, value]) => {
      if (!['mountOverrides', 'optionGroups'].includes(key)) configured[key] = clone(value);
    });
    Object.entries(policy.mountOverrides || {}).forEach(([mountId, override]) => {
      if (configured.mounts?.[mountId]) Object.assign(configured.mounts[mountId], clone(override));
    });
    Object.entries(policy.optionGroups || {}).forEach(([groupId, groupPolicy]) => {
      const group = configured.optionGroups.find((candidate) => candidate.id === groupId);
      if (!group) return;
      if (Array.isArray(groupPolicy.allowedOptionIds)) {
        const allowed = new Set(groupPolicy.allowedOptionIds);
        group.options = group.options.filter((option) => allowed.has(option.id));
      }
      Object.entries(groupPolicy.optionOverrides || {}).forEach(([optionId, override]) => {
        const option = group.options.find((candidate) => candidate.id === optionId);
        if (option) Object.assign(option, clone(override));
      });
      Object.entries(groupPolicy).forEach(([key, value]) => {
        if (!['allowedOptionIds', 'optionOverrides'].includes(key)) group[key] = clone(value);
      });
    });
    return configured;
  }

  function resolveFamilyPolicyContext(category, candidates) {
    const familyGroup = category?.optionGroups?.find((group) => group.id === 'fabric_family');
    const availableFamilyIds = new Set(
      (familyGroup?.options || [])
        .filter((option) => option.configurationEligible !== false)
        .map((option) => option.id),
    );
    const familyId = (candidates || []).find((candidate) => availableFamilyIds.has(candidate));
    return familyId ? { fabric_family: familyId } : {};
  }

  function buildRules(id, selections = {}) {
    const category = applyFamilyPolicy(getCategory(id), selections);
    if (!category) throw new Error(`Unknown no-drill category: ${id}`);
    return {
      ...category,
      version: 3,
      mode: 'catalog-v2',
      currency: 'USD',
      checkoutEnabled: false,
      orderPricing: clone(orderPricing),
    };
  }

  return {
    categories,
    orderPricing,
    getCategory,
    listCatalogCategories,
    buildRules,
    isGroupActive,
    availableOptions,
    availableControls,
    defaultOption,
    derivedOption,
    applyFamilyPolicy,
    resolveFamilyPolicyContext,
  };
});
